module.exports = __webpack_public_path__ + "img/y_p2_yunying.0e12b407.svg";